import logo from "../assets/images/logo.avif";
import manufacturingImg from "../assets/images/manufacturing-plants.jpg";
import itImg from "../assets/images/it-companies.jpg";
import commercialImg from "../assets/images/commercial-buildings.jpg";
import heroImg from "../assets/images/hero_img.jpg";
import panel1 from "../assets/images/panel_1.jpg";
import panel2 from "../assets/images/panel_2.jpg";
import panel3 from "../assets/images/panel_3.jpg";
import panelMfg from "../assets/images/Panel Manufacturing.jpg";
import manufacturingNew from "../assets/images/manufacturing_new.png";
import blueprintBg from "../assets/images/blueprint_bg.png";
import trainingPanel from "../assets/images/training_panel.png";
import welcomeVid from "../assets/videos/welcome-video.mp4";

// =============================================================================
// Prime Volt Engineering Services — Central configuration
// Replace the Google Form URLs below with your live links once available.
// =============================================================================

export const COMPANY = {
  name: "Prime Volt Engineering Services",
  short: "Prime Volt",
  tagline: "Engineering Excellence. Powering Reliable Solutions.",
  phone: "7569420742",
  phoneDisplay: "+91 7569 420 742",
  email: "primevoltengineringservices@gmail.com",
  whatsapp: "917569420742", // digits only for wa.me
  address: "India",
  logo: logo,
};

// --- GOOGLE FORMS -----------------------------------------------------------
// Paste the full "embed" URL (the one ending with ?embedded=true) or the
// standard "viewform" URL. If you want the form embedded inline, use the
// embedded URL. If you prefer opening in a new tab, the viewform URL works.
export const GOOGLE_FORMS = {
  // Form for "Discuss Your Panel Requirement"
  panelRequirement: {
    embed: "", // e.g. "https://docs.google.com/forms/d/e/XXXX/viewform?embedded=true"
    link: "",  // e.g. "https://docs.google.com/forms/d/e/XXXX/viewform"
  },
  // Form for "Free Demo Class" registration
  demoClass: {
    embed: "https://docs.google.com/forms/d/e/1FAIpQLSd157JUCWXC4aV6zhQ2sP_8N4oGUN-za_Innkvs2Y3ejh4row/viewform?embedded=true",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSd157JUCWXC4aV6zhQ2sP_8N4oGUN-za_Innkvs2Y3ejh4row/viewform?usp=publish-editor",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/about", label: "About", testId: "nav-about" },
  { to: "/services", label: "Services", testId: "nav-services" },
  { to: "/training", label: "Training", testId: "nav-training" },
  { to: "/careers", label: "Careers", testId: "nav-careers" },
  { to: "/contact", label: "Discuss Requirement", testId: "nav-contact" },
];

export const PANEL_TYPES = [
  "MCC Panel",
  "PCC Panel",
  "PMCC Panel",
  "APFC Panel",
  "Control Panel",
  "Others",
];

// =============================================================================
// IMAGE LIBRARY
// Centralised, verified public image URLs (Pexels / Unsplash).
// Use `IMG.<key>` anywhere in the app to keep visuals consistent.
// =============================================================================
const px = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600`;
const un = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1600&q=80`;

export const IMG = {
  // Hero & primary shots
  heroBreakers: heroImg,
  engineerOutdoor: px(17842832),
  multimeter: px(14319099),
  controlPanelBlue: un("photo-1775989233801-012eca66ab26"),

  // Industrial / workshop / panels
  powerLines: px(442151),
  transmission: px(257700),
  powerStation: px(257736),
  workshopA: manufacturingNew,
  workshopB: px(8005368),
  circuitMacro: px(3862130),
  factoryFloor: manufacturingImg,
  industrialSite: px(2760241),
  energyGrid: px(9875412),

  // Engineer / training / technical
  engineerTablet: un("photo-1581092918056-0c4c3acd3789"),
  controlRoom: itImg,
  panelDetail: panel1,
  switchgear: commercialImg,
  industrialPanel: panel2,
  blueprintBg: blueprintBg,
  trainingPanel: trainingPanel,
  panel3: panel3,
  panelMfg: panelMfg,
};

export const VID = {
  welcome: welcomeVid,
};
